import checkbox from './checkbox';
import frame from './frame';
import radio from './radio';
import select from './select';
import tree from './tree';
import upload from './upload';
import group from './group';


export default [
    checkbox,
    frame,
    radio,
    select,
    tree,
    upload,
    group
]
